// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)

import React from "react";
import Plotly from "../../ThirdParty/PlotlyJS/plotly-v3.4.0-afPlots.min.js";
import createPlotlyComponent from "react-plotly.js/factory.js";
import type { PlotParams } from "react-plotly.js";

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const Plot = createPlotlyComponent(Plotly);

const AFPlot = (props: PlotParams | Readonly<PlotParams>) => {
	return <Plot {...props} />;
};

export default AFPlot;
